module.exports = __webpack_public_path__ + "static/media/ozone.5f25bdd1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/weather/svg/ozone.svg
// module id = 509
// module chunks = 0